import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  sendEmailVerification,
} from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA3Fy0KJbINaMGZh3DUBTyvC3rQTleZVK8",
  authDomain: "job-tracker-2d34e.firebaseapp.com",
  projectId: "job-tracker-2d34e",
  storageBucket: "job-tracker-2d34e.firebasestorage.app",
  messagingSenderId: "1009408352473",
  appId: "1:1009408352473:web:dc53ee5938c0e23e8f5ec8",
  measurementId: "G-1EPNMJZVJ7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Google and GitHub providers
const googleProvider = new GoogleAuthProvider();
const githubProvider = new GithubAuthProvider();

// Authentication functions
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
export const signInWithGitHub = () => signInWithPopup(auth, githubProvider);
export const logoutUser = () => signOut(auth);

export const signUpWithEmail = async (email, password, displayName) => {
  const result = await createUserWithEmailAndPassword(auth, email, password);
  await updateProfile(result.user, { displayName });
  await sendEmailVerification(result.user);
  return result;
};

export const signInWithEmail = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// Firestore functions
export const saveUserJobs = async (userId, jobs) => {
  try {
    const userDoc = doc(db, "users", userId);
    await setDoc(
      userDoc,
      {
        jobs: jobs,
        lastUpdated: new Date().toISOString(),
      },
      { merge: true },
    );
    return true;
  } catch (error) {
    console.error("Error saving jobs:", error);
    return false;
  }
};

export const getUserJobs = async (userId) => {
  try {
    const userDoc = doc(db, "users", userId);
    const docSnap = await getDoc(userDoc);
    if (docSnap.exists()) {
      return docSnap.data().jobs || [];
    }
    return [];
  } catch (error) {
    console.error("Error loading jobs:", error);
    return [];
  }
};

// Auth state observer
export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

export { auth, db };
